export function initials(name: string) {
  const a = name.split(' ');

  return a.length > 1
    ? a[0].substr(0, 1) + a[1].substr(0, 1)
    : a[0].substr(0, 1);
}
